import * as yup from "yup";

export const validationSchema = yup.object().shape({
  name: yup.string().required("نام و نام خانوادگی خود را وارد کنید"),
  email: yup.string().email("ایمیل را صحیح وارد کنید").nullable(),
  password: yup
    .string()
    .required("پسورد را وارد کنید")
    .matches(
      "^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z].*[a-z].*[a-z]).{8,}$",
      "پسورد حداقل 8 کاراکتر و شامل حروف کوچک و بزرگ و اعداد است"
    ),
  mobile: yup
    .string()
    .required("شماره موبایل خود را وارد کنید")
    .matches(
      "^[0][9][0-9]{9}$" || "^[۰][۹][۰-۹]{9}$",
      "شماره اشتباه است (09xxxx)"
    ),
  phone: yup.string().nullable(),
  user_group: yup.string().required("گروه کاربری خود را وارد گنید"),
  status: yup.string().required("وضعیت کاربر را مشخص کنید"),
});

export const initialValues = {
  name: "",
  email: "",
  password: "",
  mobile: "",
  phone: "",
  user_group: "",
  status: "",
};
